import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import {
  replacePlainTextToLinksPattern,
  replacePlainTextToLinksTemplate
} from '../../../utils/lookahead-common';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { descriptionEditor } from '../../../assets/js/field_config/editor-inline-gantt';

const descriptionCol = (gantt, t) => ({
  name: 'description',
  label: 'Descripción',
  editor: descriptionEditor,
  offset: 0,
  align: 'center',
  ignore_as_column: false,
  template: function (activity) {
    let htmlH = '';
    if (activity?.description) {
      htmlH = getStringHidden(activity.description, 'description', 0);
    }
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.description;
    }

    return `
            <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
                <span class="string-v">${activity?.description?.replace(replacePlainTextToLinksPattern, replacePlainTextToLinksTemplate) ?? ''}</span>
                ${htmlH}
            </div>
            `;
  },
  data_type: 'string',
  width: 200,
  groupable: false,
  hide: !isColumnVisibleByDefault('description'),
  orderable: true,
  orderable_switch: ['A → Z', 'Z → A'],
  filterable: true,
  resize: true,
  editable: true
});

export default descriptionCol; 